
/**
 * AI 答疑官配置，在0331版本的AI面试列表中作为入口使用
 */
import IntelligentQA, {
  emptyDefault,
  getStatusLabel,
  getStatusTagType
} from "@/lib/intelligentQA/intelligent-qa";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import AiQaConfigSelect from "./ai-qa-config-select.vue";

@Component({
  components: {
    AiQaConfigSelect
  }
})
export default class AIQaConfig extends Vue {
  @Prop({}) visible!: boolean;
  @Prop({}) aiQaConfigData!: any;

  title = "";
  getStatusLabel = getStatusLabel;
  getStatusTagType = getStatusTagType;

  idleVideoDefault = "https://cdn.hina.com/video/ai-qa-listen.mp4";
  greetingFirstTimeDefault =
    "您好，欢迎来参加面试，我是您的专属AI答疑官小娜，关于面试您有什么问题都可以向小娜提问。";
  greetingAgainDefault = "嗨，又见面了，您还有什么问题想要了解吗？";
  responseSeveralMatchesDefault = "您想问的是否是以下问题？";
  responseNoMatchDefault = "很抱歉，小娜没有您这个问题的答案。";
  baseInfoForm = {
    examId: "",
    idleVideo: "",
    isEnabled: 2,
    isBeforeExam: 1,
    isAfterExam: 1,
    greetingFirstTime: "",
    greetingAgain: "",
    responseSeveralMatches: "",
    responseNoMatch: ""
  };

  loading = false;
  activeName = "first";

  @Watch("visible", { immediate: true })
  async getInfo(isShow: any) {
    console.log("🚀 ~ ApplicationRule ~ getInfo ~ isShow:", isShow);
    if (isShow) {
      // 获取答疑官配置
      this.getBot();
      // 获取答疑官下的问答对列表
      this.getBotQAList();
    } else {
      (this.$refs.baseInfoForm as any).resetFields();
    }
  }

  async getBot() {
    if (this.aiQaConfigData.examId) {
      const req = {
        examId: this.aiQaConfigData.examId
      };
      const res = await IntelligentQA.getBot(req);
      console.log("🚀 ~ ApplicationRule ~ getInfo ~ res:", res);
      this.baseInfoForm.examId = this.aiQaConfigData.examId;
      this.baseInfoForm.isEnabled = res.isEnabled;
      this.baseInfoForm.isBeforeExam = res.isBeforeExam;
      this.baseInfoForm.isAfterExam = res.isAfterExam;
      this.baseInfoForm.idleVideo = emptyDefault(
        res.idleVideo,
        this.idleVideoDefault
      );
      this.baseInfoForm.greetingFirstTime = emptyDefault(
        res.greetingFirstTime,
        this.greetingFirstTimeDefault
      );
      this.baseInfoForm.greetingAgain = emptyDefault(
        res.greetingAgain,
        this.greetingAgainDefault
      );
      this.baseInfoForm.responseSeveralMatches = emptyDefault(
        res.responseSeveralMatches,
        this.responseSeveralMatchesDefault
      );
      this.baseInfoForm.responseNoMatch = emptyDefault(
        res.responseNoMatch,
        this.responseNoMatchDefault
      );
    }
  }

  validateIsBeforeOrAfterExam = (rule, value, callback) => {
    if (
      this.baseInfoForm.isBeforeExam !== 1 &&
      this.baseInfoForm.isAfterExam !== 1
    ) {
      callback(new Error("至少选择一个"));
    } else {
      callback();
    }
  };

  checkUrl = (rule, value, callback) => {
    if (!value.startsWith("http://") && !value.startsWith("https://")) {
      callback(new Error("请输入正确的聆听态视频链接"));
    } else {
      callback();
    }
  };

  rules = {
    isBeforeOrAfterExam: [
      { validator: this.validateIsBeforeOrAfterExam, trigger: "blur" }
    ],
    idleVideo: [
      { required: true, message: "禁止为空", trigger: "blur" },
      { validator: this.checkUrl, trigger: "blur" }
    ],
    greetingFirstTime: [
      { required: true, message: "禁止为空", trigger: "blur" },
      { max: 255, message: "最多输入255个字", trigger: "blur" }
    ],
    greetingAgain: [
      { required: true, message: "禁止为空", trigger: "blur" },
      { max: 255, message: "最多输入255个字", trigger: "blur" }
    ],
    responseSeveralMatches: [
      { required: true, message: "禁止为空", trigger: "blur" },
      { max: 255, message: "最多输入255个字", trigger: "blur" }
    ],
    responseNoMatch: [
      { required: true, message: "禁止为空", trigger: "blur" },
      { max: 255, message: "最多输入255个字", trigger: "blur" }
    ]
  };

  // 面试配置：配置答疑官的 保存 按钮
  async onQABotConfigOk() {
    try {
      await this.checkData();
      if (this.loading) return;
      this.loading = true;
      await IntelligentQA.configBot(this.baseInfoForm);
      const link = this.tableData.map((v: any) => {
        return { qaId: v.id, isRecommended: v.isRecommended };
      });
      const req = {
        examId: this.aiQaConfigData.examId,
        link
      };
      IntelligentQA.configBotQA(req);
      this.$emit("ok");
      this.close();
    } catch (e) {
      console.log("🚀 ~ ApplicationRule ~ ok ~ e:", e);
      this.loading = false;
    }
  }

  // 面试配置-配置答疑官的校验功能
  async checkData(): Promise<{ code: number; message: string }> {
    return new Promise((resolve, reject) => {
      this.$refs.baseInfoForm.validate((valid: boolean) => {
        if (valid) {
          resolve({ code: 200, message: "成功" });
        } else {
          reject({ code: 201, message: " 失败" });
        }
      });
      return resolve({ code: 200, message: "成功" });
    });
  }

  // 面试配置：配置答疑官下的问答对的 保存 按钮
  async onConfigBotQASave() {
    try {
      this.saveConfigBotQA();
      this.$emit("ok");
      this.close();
    } catch (e) {
      console.log("🚀 ~ ApplicationRule ~ ok ~ e:", e);
    }
  }

  close() {
    this.$emit("update:visible", false);
  }

  listForm = {
    examId: this.aiQaConfigData.examId,
    pageNum: 1,
    pageSize: 500
  };
  total = 0;
  tableData: any = [];

  async getBotQAList() {
    const res = await IntelligentQA.getBotQA(this.listForm);
    console.log("🚀 ~ AIQaOfficerList ~ getBotQAList ~ res:", res);
    this.total = res.total;
    this.listForm.pageNum = res.pageNum;
    this.tableData = res.list;
  }

  // async saveQABotConfig() {
  //   if (this.loading) return;
  //   this.loading = true;
  //   try {
  //     IntelligentQA.configBot(this.baseInfoForm);
  //   } catch (e) {
  //     console.log(e);
  //   } finally {
  //     this.loading = false;
  //   }
  // }

  // 保存配置的问题列表
  async saveConfigBotQA() {
    if (this.loading) return;
    this.loading = true;
    try {
      const link = this.tableData.map((v: any) => {
        return { qaId: v.id, isRecommended: v.isRecommended };
      });
      const req = {
        examId: this.aiQaConfigData.examId,
        link
      };
      IntelligentQA.configBotQA(req);
    } catch (e) {
      console.log(e);
    } finally {
      this.loading = false;
    }
  }

  // 移除单条记录
  removeQaItem(index: number) {
    this.tableData.splice(index, 1);
  }

  // ================= 选择问题 =======================
  aiQaConfigSelectVisible = false;
  aiQaConfigSelectData = [] as any;
  openAiQaConfigSelectDialog() {
    this.aiQaConfigSelectData = this.tableData.map((v: any) => v.id);
    this.aiQaConfigSelectVisible = true;
  }
  // 选择问题之后，获取已经选择的问题列表，新选择的和老的做合并（如果有相同的，那么新的不覆盖老的）
  onSelectedTableDataChange(rows: any) {
    console.log("🚀 ~ AIQaConfig ~ onSelectedTableDataChange ~ rows:", rows);
    rows?.forEach((item: any) => {
      const row = this.tableData.find((v: any) => v.id === item.id);
      if (!row) {
        this.tableData.push(item);
      }
    });
  }
}
